<template>

    <q-modal v-model="editOrder"  no-backdrop-dismiss  @escape-key="unlockOrder" maximized>
             <!-- <form id="mainEditForm" action="#"  @submit.prevent="saveOrder">  -->
            <q-modal-layout  content-css=''>
                  
                <q-toolbar slot="header">

                    <q-toolbar-title>
                        Редактирование заказа № {{ newOrderData.id }}
                    </q-toolbar-title>

                    <q-btn
                        color="negative"
                        label="Отмена"
                        icon = "cancel"
                        wait-for-ripple
                        @click="cancelEdit"
                        style="margin-right: 20px;"
                    />
                    
                    <q-btn
                        color="green"
                        label="Сохранить"
                        icon = "save"
                        :disable = "saveBlock"
                        wait-for-ripple
                        type="submit"
                        @click = 'saveOrder'
                    />
                </q-toolbar>
                 
                <div class="row no-wrap q-pa-lg">

                    <div class='col-6' id='main_container'>
                        <q-select
                            name = "manager_field"
                            v-model="newOrderData.manager"
                            float-label ="Менеджера заказа"
                            filter
                            autofocus-filter
                            filter-placeholder = "Фильтр"
                            :options="getManagers"
                            class='q-ma-md'
                            separator
                            v-validate="{required : true}"
                            v-bind:class="{ error_input: errors.has('manager_field')}"
                        />
                        <span v-show="errors.has('manager_field')" style="color:red">{{ errors.first('manager_field') }}</span>

                        <div class="row no-wrap items-baseline q-pl-md q-pr-md">
                            <q-select
                                name = "contragent_field"
                                v-model="newOrderData.contragent"
                                float-label="Заказчик"
                                filter
                                autofocus-filter
                                filter-placeholder = "Фильтр"
                                placeholder ="Выберите заказчика"
                                :options="getContragents"
                                class='q-ma-md full-width'
                                separator
                                @input="changeContragent"
                                v-validate="{required : true}"
                            />
                            <span style="color:red">{{ errors.first('contragent_field') }}</span>

                           <div>
                                <q-btn outline size='sm' color='primary' icon="far fa-address-book" class='q-ml-lg' @click='addNewContragent'>
                                    <q-tooltip :delay="1000">
                                        Создать нового контрагента
                                    </q-tooltip>
                                </q-btn>
                            </div>


                        </div>

                        <q-input v-model="newOrderData.comment" float-label="Комментарии к заказу" name="comment_list" class='q-ma-md'/>

                        <q-input v-model="newOrderData.path" float-label="Путь к исходным файлам" name="path_list" class='q-ma-md'/>                
                    </div>
               
                
                    <!-- <div class="wish-container"> -->
                    <div class="col-6">
                        <q-select
                                name = "executor_field"
                                v-model="newOrderData.executor"
                                float-label="Исполнитель"
                                filter
                                autofocus-filter
                                filter-placeholder = "Фильтр"
                                :options="getExecutors"
                                class='q-ma-md'
                                separator
                        />
                        

                        <q-datetime 
                                v-model = "newOrderData.wish_date" 
                                type = "datetime" 
                                clearable 
                                float-label="Готовность заказа"
                                placeholder="Установите желаемую дату и время готовности заказа" 
                                min
                                format="( HH:mm )  D MMMM YYYY (dddd)"
                                class='q-ma-md'
                        />
                    </div>

                </div>
                <!-- <div v-if='showDownload' class='full-width row justify-center q-pa-lg'>
                        Загрузка файлов
                </div> -->

                <div style="clear: both">
                    <main-dialog-file 
                        v-for="(orderFile) in orderFiles"
                        :FileParam="orderFile"
                        :key="orderFile.id"
                        :index="orderFile.id"
                    />
                </div>
              
            </q-modal-layout>
          <!-- </form> -->
          <!-- <addContragentDialog/> -->
    </q-modal>
    
</template>

<script>
/* eslint-disable */
import mainDialogFile from './mainDialog/mainDialogFile';
// import addContragentDialog from './../contragents/contragentEditDialog';
import { scroll } from 'quasar';
const { getScrollTarget, setScrollPosition } = scroll;

export default {
    
    components :{
        mainDialogFile,
        // addContragentDialog,
    },

    data () {
            return {
                directionLabel : 'price_shirka',  //метка нужных направлений
                wish_date : new Date(),
                orderId : 0,
                editOrder: false,   
                saveBlock : false,
                // showDownload : true,
                newOrderData : {
                    id : 0,
                    manager : null,
                    contragent : null,
                    executor : null,
                    comment : '',
                    path : '',
                    wish_date : undefined,
                },
            }
    },

    beforeDestroy() {
        eventBus.$off('mainEdit');
    },

    created() {
        
        this.showDownload = true;

        eventBus.$on('mainEdit', (order)=>{
            this.orderId = order.id;
            this.$q.loading.show({
                message: 'Загрузка файлов...',
            });

            //Запрашиваем данные файлов заказа
            this.$store.dispatch('getFiles', order.id)
            .then(()=>{

                var el = document.getElementById("main_container");
                let target = getScrollTarget(el);
                setScrollPosition(target, 0, 1);

                this.$q.loading.show({
                    message: 'Загрузка прайсов...',
                });

                let contragent = this.$store.getters.getContragentById(order.contragent);

                this.$store.dispatch("getPriceById", contragent.priceId)
                .then(()=>{
                    this.$q.loading.hide();
                    this.editOrder = true;
                })
                .catch(()=>{
                    this.$q.loading.hide();
                    this.editOrder = true;
                }); //загружаем прайс лист текущего клиента

            })
            .catch(()=>{
                this.$q.loading.hide();
            });

            for (let key in order) {  //вставляем полученные поля
                this.newOrderData[key] = order[key];
            }

            this.editOrder = true;

        });

        var directions = this.$store.getters.getAllDirections; //получаем список направлений - если он пусток - то пытаемся загрузить
        if (directions.length==0) { 
            this.$store.dispatch('getDirections');
        }
        
        var materials = this.$store.getters.getAllMaterials; //получаем список направлений - если он пусток - то пытаемся загрузить
        if (materials.length==0) { 
            this.$store.dispatch('getMaterials')
            .then()
            .catch();
        }

        var quality = this.$store.getters.getAllQuality; //получаем список направлений - если он пусток - то пытаемся загрузить
        if (quality.length==0) { 
            this.$store.dispatch('getQuality');
        }

        var postTypes = this.$store.getters.getAllPostTypes; //получаем список направлений - если он пусток - то пытаемся загрузить
        if (postTypes.length==0) { 
            this.$store.dispatch('getPostTypes');
        }

    },

    methods : {
        addNewContragent() {
             eventBus.$emit('openContragentEditDialog', -1);
        },

        unlockOrder(){

            this.$store.dispatch('unlockOrder', this.orderId)
            .then()
            .catch(error => {
                this.$admns.showNotify('Не удалось разблокировать запись','error','Сообщение системы');
                console.log(error);
            });

        },

        changeContragent(newValue) {
            var contragent = this.$store.getters.getContragentById(newValue); //сменился клиент - перегружаем прайслист
            this.$store.dispatch("getPriceById", contragent.priceId);
        },

        setEmptyData() {
          this.newOrderData.manager = null;
          this.newOrderData.manager = null;
          this.newOrderData.contragent = null;
          this.newOrderData.comment = '';
          this.newOrderData.path = '';
          this.newOrderData.id = 0;
          this.newOrderData.wish_date = undefined;
          this.newOrderData.executor = undefined;

          this.$store.commit("clearAllUploadFile");

        },

        showNotify(nMessage, nType, detail='') {

                this.$admns.showNotify(nMessage, nType, detail);

        },

        cancelEdit() {
            this.editOrder = false;
            this.setEmptyData();
            this.showNotify('Отмена редактирования заказа', 'error', 'Отменено пользователем');
            this.unlockOrder();
        },

        saveOrder() {
            if (this.saveBlock) return; //если уже нажата кнопка то ничего не делаем
            var self = this;
            this.$validator.validateAll().then( (result) => {
                    if (result) {
                        this.saveBlock = true; // блокируем повторное нажатие 
                        this.$store.dispatch('updateOrder', this.newOrderData)
                        .then( () => {
                            this.showNotify('Параметры заказа сохранены', 'success')    
                            this.editOrder = false;
                            this.setEmptyData();
                            this.saveBlock = false;
                            // this.unlockOrder();
                        })
                        .catch(error => {
                            console.log(error);
                            this.saveBlock = false;
                        });
                    }
            })
            .catch((result)=>{
                console.log(result);
            });
        },


    },
    
    computed: {
  
      getContragents() {
          var list = [];
          if (this.$store.getters.allContragents==undefined) return list;
          this.$store.getters.allContragents.map((value,key)=>{
              list.push({label:value.name, value:value.id});
          });
          return list;

      },

      getExecutors() {
          var list = [];
          //получаем нужные направления
          var d = this.$store.getters.getAllDirections.filter(item => item.price_component==this.directionLabel);
// Проверяем добавлять ли строку свое производство          
          let addOwn = false;
          d.forEach(element => {
              if (element.own == 1) addOwn = true;
          });
          if (addOwn) {
              list.push({label:'Свое производство', value:0});
          }

          if (this.$store.getters.getAllExecutors==undefined) return list;
          this.$store.getters.getAllExecutors.map((value,key)=>{
              
              let addFlag = false; // проверяем нужно ли добалять такого исполнителя
              d.forEach(element => {
                  if (value.directions.indexOf(element.id) > -1) addFlag = true;
              });
              if (addFlag) list.push({label:value.name, value:value.id});

          });
          return list;

      },

      getManagers() {
          var list = [];
          if (this.$store.getters.allUsers==undefined) return list;
          this.$store.getters.allUsers.map((value,key)=>{
              list.push({label:value.name+" "+value.surname, value:value.id});
          });
          return list;
      },

      orderFiles(){
          var list = [];
          if (this.$store.getters.getOrderFiles === undefined) return list;
        //   list = this.$store.getters.getOrderFiles;
          return this.$store.getters.getOrderFiles;
      }


  },

}
</script>
<style lang="scss" scoped>
    .wish-container {
        padding : 45px;
        color : gray;
        font-family: Arial, Helvetica, sans-serif;
        
    }

</style>

